import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./route";
import { mutations } from "@/views/Home/services/store";
Vue.use(VueRouter);

export default function create() {
  const router = new VueRouter({
    routes
  });
  router.beforeEach((to, from, next) => {
    if (to.name === "address" || to.name === "detail") {
      mutations.setAddressFrom(from.path);
    }
    next();
  });
  return router;
}
